import angularToastr from "angular-toastr";
import "./toastr.less";

export default angularToastr;



// WEBPACK FOOTER //
// ./src/ui/app/services/toastr/index.js